import React, { Component } from 'react'
import MUITooltip from '@material-ui/core/Tooltip'

const setDefaultProps = (props = {}, defaults = {}) => {
  return Object.keys(defaults).reduce((allProps, key) => {
    const value = props.hasOwnProperty(key) ? props[key] : defaults[key]
    return { ...allProps, [key]: value }
  }, props)
}

class Tooltip extends Component {
  render () {
    return (
      <MUITooltip
        {...setDefaultProps(this.props, {
          enterTouchDelay: 0,
          leaveTouchDelay: 3000
        })}
      />
    )
  }
}

Tooltip.propTypes = { ...MUITooltip.propTypes }

export default Tooltip



// WEBPACK FOOTER //
// ./src/controls/Tooltip.js